import styled from "styled-components";

const Title = styled.h1`
  font-size: 2.5em;
  font-weight: 100;
  font-family: "Luckiest Guy";
  text-transform: uppercase;
`;

export default Title;
